import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { faSearch, faPencilAlt, faInfo, faCheck, faTimes, faDownload, faFileUpload, faExchangeAlt, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faFileAlt, faCheckCircle, faTimesCircle, faBell, faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { OfferService } from '../shared/services/offer-services/offer.service';
import { Filter } from '../shared/models/filter.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditOfferService } from '../shared/services/edit-offer.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RiskAssessment } from '../shared/models/offer-models/risk-assessment.model';
import { UploadDocumentationsService } from '../shared/services/offer-services/upload-documentation.service';
import { RoleSendService } from '../shared/services/role-send.service';
import { Subscription, Observable } from 'rxjs';
import { UserService } from '../shared/services/admin-services/user.service';
import { SimpleOffer } from '../shared/models/offer-models/simple-offer.model';
import { ClientStatusService } from '../shared/services/admin-services/client-status.service';
import { Lookup } from '../shared/models/admin-models/lookup.model';
import { BranchOfficeService } from '../shared/services/admin-services/branch-office.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.sass']
})
export class OffersComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faCalendarAlt = faCalendarAlt;
  faPencilAlt = faPencilAlt;
  faInfo = faInfo;
  faFileAlt = faFileAlt;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faCheck = faCheck;
  faTimes = faTimes;
  faDownload = faDownload;
  faFileUpload = faFileUpload;
  faExchangeAlt = faExchangeAlt;
  faBell = faBell;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faFileSignature = faFileSignature;

  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle: String
  successTitle: String;

  total: Number = null;
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })

  offers: any;
  offerId: Number;
  offerType: String;
  offerStatus: String;
  offerIdentStatus: Boolean;

  roleService: Subscription;
  roleType: String = '';

  riskAssessmentForm = new FormGroup({
    question1: new FormControl('', [Validators.required]),
    question2: new FormControl('', [Validators.required]),
    question3: new FormControl('', [Validators.required]),
    question4: new FormControl('', [Validators.required]),
    question5: new FormControl('', [Validators.required]),
    question6: new FormControl('', [Validators.required]),
    question7: new FormControl('', [Validators.required]),
    question8: new FormControl('', [Validators.required]),
    question9: new FormControl('', [Validators.required]),
    question10: new FormControl('', [Validators.required]),
    question11: new FormControl('', [Validators.required]),
    question12: new FormControl('', [Validators.required]),
    question13: new FormControl('', [Validators.required]),
    question14: new FormControl('', [Validators.required]),
    question15: new FormControl('', [Validators.required]),
    question16: new FormControl('', [Validators.required]),
    question17: new FormControl('', [Validators.required]),
    question18: new FormControl('', [Validators.required]),
    question19: new FormControl('', [Validators.required]),
    question20: new FormControl('', [Validators.required]),
    question21: new FormControl('', [Validators.required]),
    question22: new FormControl('', [Validators.required]),
    question23: new FormControl('', [Validators.required]),
    question24: new FormControl('', [Validators.required]),
    question25: new FormControl('', [Validators.required]),
    question26: new FormControl('', [Validators.required]),
    question27: new FormControl('', [Validators.required]),
    question28: new FormControl('', [Validators.required]),
    question29: new FormControl('', [Validators.required]),
    unableToGetData: new FormControl('')
  })

  offerForm = new FormGroup({
    offerType: new FormControl('', [Validators.required]),
    offerWeb: new FormControl('', [Validators.required]),
    offerNumber: new FormControl('', [Validators.required]),
    programType: new FormControl({ value: '', disabled: true }),
    contactorFirstname: new FormControl('', [Validators.required]),
    contactorLastname: new FormControl('', [Validators.required]),
    contactorCompanyName: new FormControl('', [Validators.required]),
    contactorTaxID: new FormControl('', [Validators.required]),
    contactorCompanyID: new FormControl('', [Validators.required]),
    contactorJMBG: new FormControl({ value: '', disabled: true }),
    contactorEmail: new FormControl('', [Validators.required]),
    contactorPhone: new FormControl('', [Validators.required]),
    contractorAddress: new FormControl('', [Validators.required]),
    contractorSettlement: new FormControl('', [Validators.required]),
    insureeFirstname: new FormControl('', [Validators.required]),
    insureeLastname: new FormControl('', [Validators.required]),
    insureeJMBG: new FormControl({ value: '', disabled: true }),
    insuranceStart: new FormControl(null, [Validators.required]),
    period: new FormControl('', [Validators.required]),
    dynamic: new FormControl('', [Validators.required]),
    insuranceSum: new FormControl('', [Validators.required]),
    premiumRate: new FormControl('', [Validators.required]),
    additionalPremiumRate: new FormControl('', [Validators.required]),
    paymentType: new FormControl('', [Validators.required]),
    clientStatus: new FormControl('', [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    copy: new FormControl(false, [])
  })

  statusForm = new FormGroup({
    status: new FormControl('', [Validators.required])
  })

  indentForm = new FormGroup({
    status: new FormControl('', [Validators.required])
  })

  hideOrShowBool: Boolean = false;
  filterDate = new Date();
  filterForm = new FormGroup({
    offerRadio: new FormControl('1'),
    dateFrom: new FormControl(null),
    dateTo: new FormControl(null),
    offerStatuses: new FormControl([
      { id: 1, name: 'U procesu potpisivanja' },
      { id: 2, name: 'Čeka potvrdu' },
      { id: 3, name: 'Potvrđeno' },
      { id: 4, name: 'Poslata' },
      { id: 5, name: 'Primljena' },
      { id: 7, name: 'U obradi' },
      { id: 8, name: 'Reklamacija' },
      { id: 11, name: 'Aktivna' }
    ]),
    offerNumber: new FormControl(''),
    offerType: new FormControl(''),
    offerProgram: new FormControl(''),
    contractor: new FormControl(''),
    insuree: new FormControl(''),
    dynamicOfPayment: new FormControl(''),
    premiumRateFrom: new FormControl(''),
    premiumRateTo: new FormControl(''),
    sumInsuredFrom: new FormControl(''),
    sumInsuredTo: new FormControl(''),
    durationFrom: new FormControl(''),
    durationTo: new FormControl(''),
    paymentType: new FormControl(''),
    phoneNumber: new FormControl(''),
    agency: new FormControl(''),
    email: new FormControl(''),
    agentId: new FormControl(''),
    appointmentType: new FormControl(''),
    branchOfficeId: new FormControl(''),
    signedRemotely: new FormControl(''),
    hadAppointment: new FormControl('')
  })

  dropdownSettings: IDropdownSettings = {};
  offerStatusesArray: { id: Number, name: String }[] = [
    {
      id: 0,
      name: 'U pripremi'
    },
    {
      id: 1,
      name: 'U procesu potpisivanja'
    },
    {
      id: 2,
      name: 'Čeka potvrdu'
    },
    {
      id: 3,
      name: 'Potvrđeno'
    },
    {
      id: 4,
      name: 'Poslata'
    },
    {
      id: 5,
      name: 'Primljena'
    },
    {
      id: 7,
      name: 'U obradi'
    },
    {
      id: 8,
      name: 'Reklamacija'
    },
    {
      id: 9,
      name: 'Poništena'
    },
    {
      id: 10,
      name: 'Odbijena'
    },
    {
      id: 11,
      name: 'Aktivna'
    }
  ]

  constructor(private offerService: OfferService, private modalService: NgbModal, private editOfferService: EditOfferService, private router: Router, private uploadDocumentationsService: UploadDocumentationsService, private roleSendService: RoleSendService, private userService: UserService, private clinetStatusService: ClientStatusService, private branchOfficeService: BranchOfficeService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: true,
      selectAllText: 'Selektuj sve',
      unSelectAllText: 'Odselektuj sve'
    };
  }

  ngOnInit() {

    this.filterDate.setMonth(this.filterDate.getMonth() + 2);
    this.filterDate.setDate(1);
    this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })

    this.getAll();
    this.getBoxViewUsers();
    this.getAllBranchOffices();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
  }

  changeRadioFilter(number) {
    if (number == 0) {
      this.filterDate = new Date();
      this.filterDate.setMonth(this.filterDate.getMonth() + 1);
      this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
      this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    } else {
      this.filterDate = new Date();
      this.filterDate.setDate(1);
      this.filterDate.setMonth(this.filterDate.getMonth() + 2);
      this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
      this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    }
  }

  getAll() {
    console.log(this.filterForm.value.offerStatuses)
    this.filter.data.Filter = { OfferStatuses: [] };
    if (this.filterForm.value.offerRadio == 0) {
      this.filter.data.Filter.AppointmentDateFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.AppointmentDateTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerRadio == 1) {
      this.filter.data.Filter.InsuranceStartFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.InsuranceStartTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerStatuses.length > 0)
      for (let i = 0; i < this.filterForm.value.offerStatuses.length; i++)
        this.filter.data.Filter.OfferStatuses.push(this.filterForm.value.offerStatuses[i].id)
    if (this.filterForm.value.offerNumber)
      this.filter.data.Filter.OfferNumber = this.filterForm.value.offerNumber
    if (this.filterForm.value.offerType)
      this.filter.data.Filter.OfferType = this.filterForm.value.offerType
    if (this.filterForm.value.offerProgram)
      this.filter.data.Filter.ProductType = this.filterForm.value.offerProgram
    if (this.filterForm.value.contractor)
      this.filter.data.Filter.Contractor = this.filterForm.value.contractor
    if (this.filterForm.value.insuree)
      this.filter.data.Filter.Insuree = this.filterForm.value.insuree
    if (this.filterForm.value.dynamicOfPayment)
      this.filter.data.Filter.PaymentFrequency = this.filterForm.value.dynamicOfPayment
    if (this.filterForm.value.premiumRateFrom)
      this.filter.data.Filter.PremiumRateFrom = this.filterForm.value.premiumRateFrom
    if (this.filterForm.value.premiumRateTo)
      this.filter.data.Filter.PremiumRateTo = this.filterForm.value.premiumRateTo
    if (this.filterForm.value.sumInsuredFrom)
      this.filter.data.Filter.SumInsuredFrom = this.filterForm.value.sumInsuredFrom
    if (this.filterForm.value.sumInsuredTo)
      this.filter.data.Filter.SumInsuredTo = this.filterForm.value.sumInsuredTo
    if (this.filterForm.value.durationFrom)
      this.filter.data.Filter.DurationFrom = this.filterForm.value.durationFrom
    if (this.filterForm.value.durationTo)
      this.filter.data.Filter.DurationTo = this.filterForm.value.durationTo
    if (this.filterForm.value.paymentType)
      this.filter.data.Filter.PaymentType = this.filterForm.value.paymentType
    if (this.filterForm.value.phoneNumber)
      this.filter.data.Filter.PhoneNumber = this.filterForm.value.phoneNumber
    if (this.filterForm.value.email)
      this.filter.data.Filter.Email = this.filterForm.value.email
    if (this.filterForm.value.agentId)
      this.filter.data.Filter.UserID = this.filterForm.value.agentId
    if (this.filterForm.value.appointmentType)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentType
    if (this.filterForm.value.branchOfficeId)
      this.filter.data.Filter.BranchOfficeIDs = [this.filterForm.value.branchOfficeId]
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false
    if (this.filterForm.value.signedRemotely == '1')
      this.filter.data.Filter.SignedRemotely = true
    if (this.filterForm.value.signedRemotely == '0')
      this.filter.data.Filter.SignedRemotely = false

    if (this.filterForm.value.hadAppointment == '1')
      this.filter.data.Filter.HasAppointment = true
    if (this.filterForm.value.hadAppointment == '0')
      this.filter.data.Filter.HasAppointment = false


    this.offerService.gridView(this.filter)
      .subscribe(
        x => {
          console.log(x)
          this.total = x.total;
          this.offers = x.data;
        }
      )
  }

  clientStatus: Observable<Lookup>;
  clientStatuses() {
    this.clientStatus = this.clinetStatusService.gridView();
  }
  copyCont() {
    if (this.offerForm.value.copy) {
      this.offerForm.get('insureeFirstname').setValue(this.offerForm.value.contactorFirstname);
      this.offerForm.get('insureeLastname').setValue(this.offerForm.value.contactorLastname);
      this.offerForm.get('insureeJMBG').setValue(this.offerForm.value.contactorJMBG);
    } else {
      this.offerForm.get('insureeFirstname').setValue('');
      this.offerForm.get('insureeLastname').setValue('');
      this.offerForm.get('insureeJMBG').setValue('');
    }
  }
  copyIfTrue() {
    if (this.offerForm.value.copy) {
      this.offerForm.get('insureeFirstname').setValue(this.offerForm.value.contactorFirstname);
      this.offerForm.get('insureeLastname').setValue(this.offerForm.value.contactorLastname);
      this.offerForm.get('insureeJMBG').setValue(this.offerForm.value.contactorJMBG);
    }
  }
  openEditOfferModal(modal, id) {
    this.offerId = id;
    this.clientStatuses();
    this.offerService.getOne(id)
      .then(
        (x: any) => {
          console.log(x)
          // console.log({ year: x.insuranceStart.split('T')[0].split('-')[0], month: x.insuranceStart.split('T')[0].split('-')[1], day: x.insuranceStart.split('T')[0].split('-')[2] })
          this.offerForm.get('offerNumber').setValue(x.offerNumber)
          this.offerForm.get('programType').setValue(x.productType)
          if (x.productType != 10) {
            this.offerForm.get('contactorFirstname').setValue(x.contractor.firstname)
            this.offerForm.get('contactorLastname').setValue(x.contractor.lastname)
            this.offerForm.get('contactorJMBG').setValue(x.contractor.jmbg)
          }
          if (x.productType == 10) {
            this.offerForm.get('contactorCompanyName').setValue(x.contractor.companyName)
            this.offerForm.get('contactorTaxID').setValue(x.contractor.taxID)
            this.offerForm.get('contactorCompanyID').setValue(x.contractor.companyID)
          }
          this.offerForm.get('contactorPhone').setValue(x.contractor.mobile)
          this.offerForm.get('contactorEmail').setValue(x.contractor.email)
          this.offerForm.get('copy').setValue(x.contractorIsInsuree)
          this.offerForm.get('insureeFirstname').setValue(x.insuree.firstname)
          this.offerForm.get('insureeLastname').setValue(x.insuree.lastname)
          this.offerForm.get('insureeJMBG').setValue(x.insuree.jmbg)
          this.offerForm.get('insuranceStart').setValue({ year: parseInt(x.insuranceStart.split('T')[0].split('-')[0]), month: parseInt(x.insuranceStart.split('T')[0].split('-')[1]), day: parseInt(x.insuranceStart.split('T')[0].split('-')[2]) })
          this.offerForm.get('period').setValue(x.duration)
          this.offerForm.get('dynamic').setValue(x.paymentFrequency)
          this.offerForm.get('insuranceSum').setValue(x.sumInsured)
          this.offerForm.get('premiumRate').setValue(x.premiumRate)
          if (x.additionalPremiumRate)
            this.offerForm.get('additionalPremiumRate').setValue(x.additionalPremiumRate.toString())
          else
            this.offerForm.get('additionalPremiumRate').setValue('')
          this.offerForm.get('paymentType').setValue(x.paymentType)
          this.offerForm.get('clientStatus').setValue(x.clientStatusID)
          this.offerForm.get('comment').setValue(x.comment)

          this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
        }
      )
  }
  offerStandardEdit() {
    let offerNumberRegex = new RegExp('^SL[0-9]{10}$')
    if (!offerNumberRegex.test(this.offerForm.value.offerNumber.toUpperCase())) {
      this.errorTitle = "Nije pravilno unet broj ponude. Mora da pocinje sa SL i da ima 10 brojnih karaktera";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      let offer = new SimpleOffer({
        OfferID: this.offerId,
        OfferNumber: this.offerForm.value.offerNumber,
        ProductType: this.offerForm.get('programType').value,
        ContractorFirstname: this.offerForm.get('programType').value != '10' ? this.offerForm.value.contactorFirstname : '',
        ContractorLastname: this.offerForm.get('programType').value != '10' ? this.offerForm.value.contactorLastname : '',
        ContractorJMBG: this.offerForm.get('programType').value != '10' ? this.offerForm.get('contactorJMBG').value : '00000' + this.offerForm.value.contactorCompanyID,
        ContractorPhoneNumber: this.offerForm.value.contactorPhone,
        ContractorEmail: this.offerForm.value.contactorEmail,
        ContractorCompanyName: this.offerForm.get('programType').value == '10' ? this.offerForm.value.contactorCompanyName : '',
        ContractorTaxID: this.offerForm.get('programType').value == '10' ? this.offerForm.value.contactorTaxID : '',
        ContractorCompanyID: this.offerForm.get('programType').value == '10' ? this.offerForm.value.contactorCompanyID : '',
        ContractorIsInsuree: this.offerForm.value.copy,
        InsureeFirstname: this.offerForm.value.insureeFirstname,
        InsureeLastname: this.offerForm.value.insureeLastname,
        InsureeJMBG: this.offerForm.get('insureeJMBG').value,
        InsuranceStart: this.offerForm.value.insuranceStart.year + '-' + this.offerForm.value.insuranceStart.month + '-' + this.offerForm.value.insuranceStart.day,
        InsuranceEnd: (this.offerForm.value.insuranceStart.year + this.offerForm.value.period) + '-' + this.offerForm.value.insuranceStart.month + '-' + this.offerForm.value.insuranceStart.day,
        Duration: this.offerForm.value.period,
        PaymentFrequency: this.offerForm.value.dynamic,
        SumInsured: this.offerForm.value.insuranceSum,
        PremiumRate: this.offerForm.value.premiumRate,
        AdditionalPremiumRate: Number(this.offerForm.value.additionalPremiumRate),
        PaymentType: this.offerForm.value.paymentType,
        ClientStatusID: this.offerForm.value.clientStatus,
        Comment: this.offerForm.value.comment
      })
      console.log(offer)
      this.offerService.simpleEditOffer(offer)
        .then(
          x => {
            console.log(x);
            this.getAll();
            this.modalService.dismissAll()
          },
          (x: { error: String }) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    }
  }

  filesMobile;
  onFileChanged(event, id) {
    const formData = new FormData();
    formData.append('OfferID', id);
    this.filesMobile = event.target.files
    for (var i = 0; i < this.filesMobile.length; i++) {
      formData.append('Files', this.filesMobile[i])
    }
    this.uploadDocumentationsService.uploadUserDoc(formData)
      .subscribe(
        x => {
          console.log(x);
          this.filesMobile = [];
          this.successTitle = "Uspešno ste prebacili podatke";
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static' })
          this.getAll()
        },
        (e: { error: String }) => {
          this.errorTitle = e.error;
          this.modalService.open(this.alertModal, { centered: true })
        }
      )
  }

  offer;
  pdfSrc1;
  pdfSrc;
  openDetailModal(id, modal, type) {
    console.log(id)
    this.offerType = type;
    if (type == 'Standardna') {
      this.offerService.getOne(id)
        .then(
          (x: any) => {
            console.log(x)
            this.offer = x;
            this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
            console.log(x)
          }
        )
    } else if (type == 'Digitalna') {
      this.offerService.previewDocument(id, 0, 0)
        .then(
          (x: any) => {
            let pdfFile = new Blob([x.body], { type: 'application/pdf' });
            let urlPdf = window.URL.createObjectURL(pdfFile)
            this.pdfSrc1 = urlPdf
            this.offerService.previewDocument(id, 1, 0)
              .then(
                (x: any) => {
                  let pdfFile = new Blob([x.body], { type: 'application/pdf' });
                  let urlPdf = window.URL.createObjectURL(pdfFile)
                  this.pdfSrc = urlPdf
                  this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
                }
              )
          }
        )
    }
  }


  openFormModal(modal, id) {
    this.offerId = id;
    this.offerService.getOne(id)
      .then(
        (x: any) => {
          console.log(x);
          this.riskAssessmentForm.reset()
          this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
          if (x.offerType == 1) {
            if (x.spnftForm.isPoliticianOrCloseAssociate) {
              this.riskAssessmentForm.get('question11').setValue('0');
              this.riskAssessmentForm.get('question11').disable();
            } else {
              this.riskAssessmentForm.get('question11').enable();
            }
          }

        }
      )
  }
  addRiskAssessment() {
    if (this.riskAssessmentForm.valid) {
      let risk = new RiskAssessment({
        OfferID: this.offerId,
        Q1: this.riskAssessmentForm.value.question1 == '0' ? true : false,
        Q2: this.riskAssessmentForm.value.question2 == '0' ? true : false,
        Q3: this.riskAssessmentForm.value.question3 == '0' ? true : false,
        Q4: this.riskAssessmentForm.value.question4 == '0' ? true : false,
        Q5: this.riskAssessmentForm.value.question5 == '0' ? true : false,
        Q6: this.riskAssessmentForm.value.question6 == '0' ? true : false,
        Q7: this.riskAssessmentForm.value.question7 == '0' ? true : false,
        Q8: this.riskAssessmentForm.value.question8 == '0' ? true : false,
        Q9: this.riskAssessmentForm.value.question9 == '0' ? true : false,
        Q10: this.riskAssessmentForm.value.question10 == '0' ? true : false,
        Q11: this.riskAssessmentForm.get('question11').value == '0' ? true : false,
        Q12: this.riskAssessmentForm.value.question12 == '0' ? true : false,
        Q13: this.riskAssessmentForm.value.question13 == '0' ? true : false,
        Q14: this.riskAssessmentForm.value.question14 == '0' ? true : false,
        Q15: this.riskAssessmentForm.value.question15 == '0' ? true : false,
        Q16: this.riskAssessmentForm.value.question16 == '0' ? true : false,
        Q17: this.riskAssessmentForm.value.question17 == '0' ? true : false,
        Q18: this.riskAssessmentForm.value.question18 == '0' ? true : false,
        Q19: this.riskAssessmentForm.value.question19 == '0' ? true : false,
        Q20: this.riskAssessmentForm.value.question20 == '0' ? true : false,
        Q21: this.riskAssessmentForm.value.question21 == '0' ? true : false,
        Q22: this.riskAssessmentForm.value.question22 == '0' ? true : false,
        Q23: this.riskAssessmentForm.value.question23 == '0' ? true : false,
        Q24: this.riskAssessmentForm.value.question24 == '0' ? true : false,
        Q25: this.riskAssessmentForm.value.question25 == '0' ? true : false,
        Q26: this.riskAssessmentForm.value.question26 == '0' ? true : false,
        Q27: this.riskAssessmentForm.value.question27 == '0' ? true : false,
        Q28: this.riskAssessmentForm.value.question28 == '0' ? true : false,
        Q29: this.riskAssessmentForm.value.question29 == '0' ? true : false,
        UnableToGetData: false
      })
      this.offerService.createRiskAssessment(risk)
        .then(
          x => {
            this.getAll();
            this.modalService.dismissAll();
          }
        )
    } else {
      // console.log("now checked wverything")
      this.errorTitle = "Niste odgovorili na sva pitanja";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

  editOffer(id, productType) {
    this.editOfferService.sendOfferID(id);
    if (productType == 'Standard' || productType == 'Standard plus' || productType == 'Standard pro') {
      this.router.navigate(['/sava/calculator/standard-calculation-insured-sum'])
    }
    if (productType == 'Najlife') {
      this.router.navigate(['/sava/calculator/naj-life-calculation-insured-sum'])
    }
    if (productType == 'Sigurnost' || productType == 'Sigurnost plus') {
      this.router.navigate(['/sava/calculator/security-calculation-insured-sum'])
    }
    if (productType == 'Adut') {
      this.router.navigate(['/sava/calculator/adut-calculation-insured-sum'])
    }
    if (productType == 'Stipendija') {
      this.router.navigate(['/sava/calculator/scholarship-calculation-insured-sum'])
    }
    if (productType == 'Sigurnost kredit') {
      this.router.navigate(['/sava/calculator/security-credit'])
    }
    if (productType == 'Zlatna jesen') {
      this.router.navigate(['/sava/calculator/golden-autumn'])
    }
    if(productType == 'Progresiv'){
      this.router.navigate(['/sava/calculator/progresive'])
    }
    if(productType == 'Standard VIP' || productType == 'Standard plus VIP' || productType == 'Standard pro VIP'){
      this.router.navigate(['/sava/calculator/vip-standard-insurance-sum'])
    }
    if(productType == 'Sigurnost VIP' || productType == 'Sigurnost plus VIP'){
      this.router.navigate(['/sava/calculator/vip-security-insurance-sum'])
    }
    if(productType == 'Stipendija VIP'){
      this.router.navigate(['/sava/calculator/vip-scholarship-insurance-sum'])
    }
  }

  openDownloadModal(modal, id) {
    // this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
    this.offerService.getRiskAssessmentPdf(id)
      .then(
        (x: any) => {
          // console.log(x);
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();

        },
        (e: { error: String }) => {
          console.log(e);
          this.errorTitle = "Nije moguće izvršiti operaciju. Proverite da li su svi parametri popunjeni: potpis zastupnika, mobilni telefon, email i sl.";
          this.modalService.open(this.alertModal, { centered: true })
        }
      )
  }

  exportOffers() {
    this.filter.data.Filter = { OfferStatuses: [] };
    if (this.filterForm.value.offerRadio == 0) {
      this.filter.data.Filter.AppointmentDateFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.AppointmentDateTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerRadio == 1) {
      this.filter.data.Filter.InsuranceStartFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.InsuranceStartTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerStatuses.length > 0)
      for (let i = 0; i < this.filterForm.value.offerStatuses.length; i++)
        this.filter.data.Filter.OfferStatuses.push(this.filterForm.value.offerStatuses[i].id)
    if (this.filterForm.value.offerNumber)
      this.filter.data.Filter.OfferNumber = this.filterForm.value.offerNumber
    if (this.filterForm.value.offerType)
      this.filter.data.Filter.OfferType = this.filterForm.value.offerType
    if (this.filterForm.value.offerProgram)
      this.filter.data.Filter.ProductType = this.filterForm.value.offerProgram
    if (this.filterForm.value.contractor)
      this.filter.data.Filter.Contractor = this.filterForm.value.contractor
    if (this.filterForm.value.insuree)
      this.filter.data.Filter.Insuree = this.filterForm.value.insuree
    if (this.filterForm.value.dynamicOfPayment)
      this.filter.data.Filter.PaymentFrequency = this.filterForm.value.dynamicOfPayment
    if (this.filterForm.value.premiumRateFrom)
      this.filter.data.Filter.PremiumRateFrom = this.filterForm.value.premiumRateFrom
    if (this.filterForm.value.premiumRateTo)
      this.filter.data.Filter.PremiumRateTo = this.filterForm.value.premiumRateTo
    if (this.filterForm.value.sumInsuredFrom)
      this.filter.data.Filter.SumInsuredFrom = this.filterForm.value.sumInsuredFrom
    if (this.filterForm.value.sumInsuredTo)
      this.filter.data.Filter.SumInsuredTo = this.filterForm.value.sumInsuredTo
    if (this.filterForm.value.durationFrom)
      this.filter.data.Filter.DurationFrom = this.filterForm.value.durationFrom
    if (this.filterForm.value.durationTo)
      this.filter.data.Filter.DurationTo = this.filterForm.value.durationTo
    if (this.filterForm.value.paymentType)
      this.filter.data.Filter.PaymentType = this.filterForm.value.paymentType
    if (this.filterForm.value.phoneNumber)
      this.filter.data.Filter.PhoneNumber = this.filterForm.value.phoneNumber
    if (this.filterForm.value.email)
      this.filter.data.Filter.Email = this.filterForm.value.email
    if (this.filterForm.value.agentId)
      this.filter.data.Filter.UserID = this.filterForm.value.agentId
    if (this.filterForm.value.appointmentType)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentType
    if (this.filterForm.value.branchOfficeId)
      this.filter.data.Filter.BranchOfficeIDs = [this.filterForm.value.branchOfficeId]
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false
    if (this.filterForm.value.signedRemotely == '1')
      this.filter.data.Filter.SignedRemotely = true
    if (this.filterForm.value.signedRemotely == '0')
      this.filter.data.Filter.SignedRemotely = false

    this.offerService.offersExcel(this.filter)
      .subscribe(
        (x: any) => {
          // console.log(x);
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = "Ponude.xlsx";
          console.log(filename)
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();

        }
      )
  }

  changeStatusBool: Boolean = true;
  openChangeStatusModal(modal, id, type, status) {
    this.changeStatusBool = false;
    this.offerId = id;
    this.offerType = type;
    this.offerStatus = status;
    console.log(this.offerType);
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  changeStatus() {
    this.changeStatusBool = true;
    let obj: Object = {
      NewOfferStatus: this.statusForm.value.status,
      OfferID: this.offerId
    }
    this.offerService.changingStatus(obj)
      .then(
        x => {
          console.log(x);
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }


  openChangeIdentificationTypeModal(modal, id) {
    this.offerId = id;
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  changeIdentType() {
    this.offerService.changeIdentType(this.offerId, this.indentForm.value.status)
      .then(
        x => {
          console.log(x)
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openIdentifieOfferModal(modal, id, status) {
    this.offerId = id;
    this.offerIdentStatus = !status;
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  changeIdentificFin() {
    this.offerService.changeIdentStatus(this.offerId, this.offerIdentStatus)
      .then(
        x => {
          console.log(x);
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  boxUserArray: Observable<any>;
  getBoxViewUsers() {
    let fil = new Filter({ Top: null, Page: null, Filter: {}, Sort: { SortBy: 'Active', Direction: 1 } });
    if (this.filterForm.value.branchOfficeId)
      fil.data.Filter.BranchOfficeID = this.filterForm.value.branchOfficeId
    this.boxUserArray = this.userService.boxView(fil)
  }

  hideOrShow() {
    this.hideOrShowBool = !this.hideOrShowBool;
  }

  brankOfficeArray: Observable<Lookup[]>
  getAllBranchOffices() {
    this.brankOfficeArray = this.branchOfficeService.boxView();
  }

  clearFilters() {
    this.filterForm.reset({ dateFrom: { year: this.filterForm.value.dateFrom.year, month: this.filterForm.value.dateFrom.month, day: this.filterForm.value.dateFrom.day }, dateTo: { year: this.filterForm.value.dateTo.year, month: this.filterForm.value.dateTo.month, day: this.filterForm.value.dateTo.day }, offerRadio: this.filterForm.value.offerRadio, offerNumber: '', offerType: '', offerProgram: '', contractor: '', insuree: '', dynamicOfPayment: '', premiumRateFrom: '', premiumRateTo: '', sumInsuredFrom: '', sumInsuredTo: '', durationFrom: '', durationTo: '', paymentType: '', phoneNumber: '', email: '', agentId: '', appointmentType: '', branchOfficeId: '', offerStatuses: [{ id: 1, name: 'U procesu potpisivanja' }, { id: 2, name: 'Čeka potvrdu' }, { id: 3, name: 'Potvrđeno' }, { id: 4, name: 'Poslata' }, { id: 5, name: 'Primljena' }, { id: 7, name: 'U obradi' }, { id: 8, name: 'Reklamacija' }, { id: 11, name: 'Aktivna' }] })
    this.getAll();
  }

  signingOfferId: Number;
  riskAssessmentBool: Boolean;
  openSendSigningAgain(modal, id, riskBool) {
    this.signingOfferId = id;
    this.riskAssessmentBool = riskBool;
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }

  openSignOnSiteModal(modal) {
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }

  openSignOnDistanceModal(modal) {
    if (this.riskAssessmentBool) {
      this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
    } else {
      this.errorTitle = "Ne možete poslati email jer Obrazac I nije popunjen";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

  openRiskModal() {
    this.offerService.sentSignRequest(this.signingOfferId)
      .then(
        x => {
          console.log(x);
          this.modalService.dismissAll();
          this.successTitle = "Uspešno ste kreirali poslali email";
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
        }
      )
  }

  signOnSpot() {
    this.offerService.sendLocalDocuments(this.signingOfferId)
      .then(
        x => {
          this.modalService.dismissAll();
          this.router.navigate(['/sign-documents-on-spot/' + this.signingOfferId]);
          // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.signingOfferId) })
        }
      )
  }

}
